import React from 'react';
import { connect } from 'react-redux';
import { ProgressBar } from 'react-toolbox/lib/progress_bar';
import BrowseMediaFacetBar from 'browse-media/components/BrowseMediaFacetBar';
import BrowseMediaFacetMenu from 'browse-media/components/BrowseMediaFacetMenu';
import SelectionActionBar from 'components/SelectionActionBar';
import {
  selectAll,
  showAddModulesDrawer,
  showRemoveModulesDrawerForSelections,
} from 'browse-media/redux/browseMediaActions';
import BrowseMediaSearchInput from 'browse-media/components/BrowseMediaSearchInput';
import BrowseMediaSearchResultsTable from 'browse-media/components/BrowseMediaSearchResultsTable';
import styles from 'browse-media/components/BrowseMediaSearch.css';

const BrowseMediaSearch = ({
  mediaList,
  onSelectAll,
  onSelectionActionBarAdd,
  onSelectionActionBarRemove,
  searching,
  selectedMediaIds,
  selectedItemsModuleIds,
  syncingMediaIds,
  totalCount,
}) =>
  <div className={styles.container}>
    <div className={styles.header}>
      <div className={styles.searchBar}>
        {searching
          ? <div className={styles.countContainer}>
              <ProgressBar
                theme={styles}
                type="circular"
                mode="indeterminate"
              />
            </div>
          : <div className={styles.countContainer}>
              <span className={styles.count}>
                {totalCount.toLocaleString()}
              </span>{' '}
              &nbsp;
              <span className={styles.itemsLabel}>items</span>
            </div>}
        <div className={styles.inputContainer}>
          <BrowseMediaSearchInput />
          <BrowseMediaFacetMenu />
        </div>
      </div>

      <BrowseMediaFacetBar />

      {selectedMediaIds.length > 0 &&
        <SelectionActionBar
          addText="Add to modules"
          removeText="Remove from modules"
          selectedCount={selectedMediaIds.length}
          onBack={() => onSelectAll(false)}
          onAdd={onSelectionActionBarAdd}
          onRemove={
            selectedItemsModuleIds.length > 0
              ? onSelectionActionBarRemove
              : false
          }
          actionsDisabled={selectedMediaIds.some(id =>
            syncingMediaIds.includes(id),
          )}
        />}
    </div>

    <div className={styles.tableContainer}>
      <BrowseMediaSearchResultsTable />
    </div>
  </div>;

const mapStateToProps = state => {
  const {
    mediaList,
    searching,
    selectedItemsModuleIds,
    selectedMediaIds,
    syncingMediaIds,
    totalCount,
  } = state.browseMedia;

  return {
    mediaList,
    searching,
    selectedItemsModuleIds,
    selectedMediaIds,
    syncingMediaIds,
    totalCount,
  };
};

const mapDispatchToProps = dispatch => ({
  onSelectAll: selected => dispatch(selectAll(selected)),
  onSelectionActionBarAdd: () => dispatch(showAddModulesDrawer()),
  onSelectionActionBarRemove: mediaId =>
    dispatch(showRemoveModulesDrawerForSelections()),
});

export default connect(mapStateToProps, mapDispatchToProps)(BrowseMediaSearch);
